import { Search, X } from "lucide-react";

export type RoleOption = { value: string; label: string };

type Props = {
  search: string;
  onSearchChange: (v: string) => void;
  roleFilter: string;
  onRoleFilterChange: (v: string) => void;
  statusFilter: string;
  onStatusFilterChange: (v: string) => void;
  roleOptions: RoleOption[];
  hasActiveFilters: boolean;
  onClear: () => void;
};

/** Busca + filtros da lista de membros — tudo client-side de propósito (equipes ainda são
 *  pequenas). Opções de papel são as que `roleOptions` mandar — só o pai sabe quais papéis
 *  realmente existem entre os membros atuais. */
export function TeamMembersToolbar({
  search,
  onSearchChange,
  roleFilter,
  onRoleFilterChange,
  statusFilter,
  onStatusFilterChange,
  roleOptions,
  hasActiveFilters,
  onClear,
}: Props) {
  return (
    <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
      <div className="relative w-full min-w-0 sm:w-auto sm:flex-1">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-zinc-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por nome ou email"
          className="h-11 w-full rounded-md border border-zinc-200 bg-white pl-8 pr-2.5 text-base text-zinc-700 placeholder:text-zinc-400 sm:h-8 sm:text-[12.5px] dark:border-border dark:bg-background dark:text-foreground"
        />
      </div>

      {/* Grade que decide sozinha pela LARGURA REAL do controle, não por modelo de aparelho:
          `auto-fit` com `minmax(7.5rem, 1fr)` mantém os dois lado a lado enquanto cada um couber
          em 112px — cabem lado a lado até em 320px, onde o card deixa 238px úteis — e empilha
          abaixo disso. O limiar caiu junto com o rótulo: "Papéis"/"Status" no
          lugar de "Todos os papéis"/"Todos os status" — quando um valor está escolhido, é ele que
          aparece ("Dentista", "Ativo"), que é a informação que importa.

          A fonte volta a 14px aqui de propósito: o zoom do iOS só acontece em campo de TEXTO,
          nunca em `select`, então não há motivo pra 16px espremer o rótulo. */}
      <div className="grid grid-cols-[repeat(auto-fit,minmax(7rem,1fr))] gap-2 sm:contents">
      <select
        value={roleFilter}
        onChange={(e) => onRoleFilterChange(e.target.value)}
        className="h-11 w-full min-w-0 rounded-md border border-zinc-200 bg-white px-2 text-sm font-medium text-zinc-700 sm:h-8 sm:w-auto sm:shrink-0 sm:text-[12.5px] dark:border-border dark:bg-background dark:text-foreground"
      >
        <option value="">Papéis</option>
        {roleOptions.map((r) => (
          <option key={r.value} value={r.value}>
            {r.label}
          </option>
        ))}
      </select>

      <select
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        className="h-11 w-full min-w-0 rounded-md border border-zinc-200 bg-white px-2 text-sm font-medium text-zinc-700 sm:h-8 sm:w-auto sm:shrink-0 sm:text-[12.5px] dark:border-border dark:bg-background dark:text-foreground"
      >
        <option value="">Status</option>
        <option value="ACTIVE">Ativo</option>
        <option value="SUSPENDED">Suspenso</option>
      </select>
      </div>

      {hasActiveFilters && (
        <button
          type="button"
          onClick={onClear}
          className="inline-flex h-11 shrink-0 items-center gap-1 rounded-md px-2 text-[12.5px] font-medium text-zinc-500 transition-colors hover:bg-zinc-100 hover:text-zinc-700 sm:h-8 dark:text-muted-foreground dark:hover:bg-muted"
        >
          <X className="h-3.5 w-3.5" />
          Limpar filtros
        </button>
      )}
    </div>
  );
}
